exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.checked[data-v-874410d6]{fill:#4f8df7\n}\n.unchecked[data-v-874410d6]{fill:#cbcbcb\n}\n", ""]);

// exports
